import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

// Cognito redirects here after clearing the SSO session.
// We set the justLoggedOut flag (prevents LoginPage from auto-triggering
// signinRedirect) and immediately send the user to /login.
const LogoutCallbackPage: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        sessionStorage.setItem('justLoggedOut', 'true');
        navigate('/login', { replace: true });
    }, [navigate]);

    return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
            <CircularProgress />
        </Box>
    );
};

export default LogoutCallbackPage;
